<template>
  <div class="tw-fixed tw-bottom-8 tw-right-8 tw-z-50">
    <a
      :href="appConfig.calendlyUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="tw-bg-primary-600 tw-text-white tw-px-6 tw-py-3.5 tw-rounded-full tw-shadow-lg hover:tw-bg-primary-700 tw-transition-all tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-text-sm hover:tw-shadow-xl"
    >
      <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      Schedule a Demo
    </a>
  </div>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>

